export default "<div class=\"formInputError--inputRestrictionPopup\"></div>\n";